import React from 'react'
// components
import Dropzone from 'react-dropzone'
// icons
import PhotoCameraIcon from '@mui/icons-material/PhotoCameraRounded'
// views
import { AvatarOverlay, Wrapper } from '../../views'
// constants
import { ALLOWED_IMAGE_TYPES } from 'utils/validators'

interface Props {
  avatar?: string
  onUpload: (...args: any) => void
  description: string
}

const AvatarUpload: React.FC<Props> = ({ avatar, onUpload, description }) => {
  return (
    <Dropzone multiple={false} onDrop={onUpload}>
      {({ getRootProps, getInputProps }) => (
        <Wrapper>
          <input {...getInputProps()} accept={ALLOWED_IMAGE_TYPES.join(',')} />
          <AvatarOverlay {...getRootProps()} avatar={avatar}>
            <PhotoCameraIcon color={'inherit'} fontSize='large' />
            <span>{description}</span>
          </AvatarOverlay>
        </Wrapper>
      )}
    </Dropzone>
  )
}

export default AvatarUpload
